import {HttpRequest} from '../../settings/HttpRequest/HttpRequest';
import {DateFormat} from "../../settings/DateFormat/DateFormat";

export const VentasRapidasService = {
	Listar: (filtro, paginacion) => {
		let fecha_inicio = (filtro.fecha_inicio || null) ? DateFormat.FormatSql(filtro.fecha_inicio) : null;
		let fecha_fin = (filtro.fecha_fin || null) ? DateFormat.FormatSql(filtro.fecha_fin) : null;
		
		let params = {
			filtro: {
				id_cliente: filtro.id_cliente || null,
				concepto: filtro.concepto || null,
				cantidad: filtro.cantidad || null,
				importe: filtro.importe || null,
				fecha_inicio: fecha_inicio,
				fecha_fin: fecha_fin,
				activo: filtro.activo ? 1:0
			},
			paginacion: {
				total: paginacion.total || null,
				page: paginacion.page || null,
				limit: paginacion.limit || null
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Ventas_Rapidas_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Detalles: (id_venta_rapida) => {
		let params = {
			id_venta_rapida: id_venta_rapida,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Ventas_Rapidas_Detalle', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Guardar: (form) => {
		let ws = '_Ventas_Rapidas_Agregar';
		let id_venta_rapida = null;
		if (form.id_venta_rapida > 0) {
			ws = '_Ventas_Rapidas_Modificar';
			id_venta_rapida = form.id_venta_rapida;
		}
		let fecha = (form.fecha || null) ? DateFormat.FormatSql(form.fecha) : null;
	
		let params = {
			id_venta_rapida: id_venta_rapida,
			id_cliente: form.id_cliente,
			fecha: fecha,
			suma: form.desglose.suma,
			iva: form.desglose.iva,
			subtotal: form.desglose.subtotal,
			total: form.desglose.total,
			lista_ordenes: form.lista_ordenes,
			activo: form.activo ? 1 : 0,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post(ws, params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_venta_rapida) => {
		let params = {
			id_venta_rapida: id_venta_rapida
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Ventas_Rapidas_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
};
